import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ExamsByCode } from '../templates/exams-config/ExamsByCode.class';
import { ExamsTemplateContainerService } from './exams-template-container.service';
import { DatabaseService } from '@app/database/database.service';


@Component({
  selector: 'app-examns-template-container',
  templateUrl: './examns-template-container.component.html',
  styleUrls: ['./examns-template-container.component.scss'],
})
export class ExamnsTemplateContainerComponent implements OnInit {
  examsByCode = new ExamsByCode().data;
  examData: any;
  selectedTemplate: any;

  // templates = data;
  // counterFindTemplates = 0;
  // counter = 0;


  constructor(
    private databaseService: DatabaseService,
    private examsTemplateService: ExamsTemplateContainerService,
    private actRoute: ActivatedRoute
  ) {
    this.examsTemplateService.examData.subscribe(
      (examData) => (this.examData = examData)
    );
  }

  async ngOnInit(): Promise<void> {
    // await this.templateSearchManager();
    await this.setTemplateToExamen();
  }

  /**
   * Este método es el encargado de administrar las búsquedas del
   * template correspondiente
   */
  // private async templateSearchManager() {
  //   await this.defineTemplate()
  //     .then((element) => (this.selectedTemplate = element))
  //     .catch(async (err) => {
  //       this.counter++;
  //       if (this.counter < data.templates.length) {
  //         await this.templateSearchManager();
  //       }
  //     });
  // }

  /**
   * Este método tiene como fin definir que template debe cargarse con base en el tipo de examen
   */
  // private async defineTemplate() {
  //   this.setTemplateToExamen();
  //   const examType = this.examData.codigoTipoExamen;
  //   try {
  //     return await this.findTemplate(
  //       examType,
  //       this.templates.templates[this.counter]
  //     );
  //   } catch (err) {
  //     throw err;
  //   }
  // }

  /**
   * Este método tiene como objetivo buscar en un array dado un elemento y
   *  manejar la transacción como una promesa
   */
  // private findTemplate(examType: string, arrayTemplate: any) {
  //   const promise = new Promise((resolve, reject) => {
  //     const result = arrayTemplate.exams.find(
  //       (element) => element.codExamen === examType
  //     );
  //     result ? resolve(arrayTemplate) : reject('No se encontró');
  //   });
  //   return promise;
  // }



  /**
   * refactor para unir template y examen sin perder la vista actual
   */
   private async setTemplateToExamen(): Promise<void> {
    const examId =  this.actRoute.snapshot.params.id;
    const examCode =  this.actRoute.snapshot.params.codigoTipoExamen;
    const categoriaParam = this.actRoute.snapshot.params.categoriaExamen;

    const examenTable =
      categoriaParam === 'reconfirmacion'
        ? 'examenesReevaluacion'
        : categoriaParam === 'examenesReconfirmacionFiltrados'
        ? 'examenesReevaluacionFiltrados'
        : categoriaParam === 'examenesPeriodicosFiltrados'
        ? 'examenesPeriodicosFiltrados'
        : categoriaParam === 'periodicos'
        ? 'examenesPeriodicos'
        : categoriaParam;

    this.examData = await this.databaseService.getSingleExamenItem(examenTable, parseInt(examId, 10));
    this.selectedTemplate = await this.examsByCode[examCode];
  }
}
